// extracted by mini-css-extract-plugin
module.exports = {"icon":"_2xJImqEbtyMwh6a0gfbdAe"};